import { Router } from "./routing/Router";

const App = () => {
  return (
    <div className="App">
      <Router />
    </div>
  );
};

export default App;
